'use client';

import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

type ThemeToggleProps = {
  className?: string;
  /** Ícone menor no header compacto */
  compact?: boolean;
};

export default function ThemeToggle({ className = '', compact = false }: ThemeToggleProps) {
  const { resolvedDark, cycleThemePreference } = useTheme();

  const themeLabel = resolvedDark
    ? 'Tema escuro — clique para modo claro'
    : 'Tema claro — clique para modo escuro';

  const ThemeIcon = resolvedDark ? Sun : Moon;
  const size = compact ? 15 : 16;

  const handleClick = () => {
    cycleThemePreference();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ||
        'flex size-9 items-center justify-center rounded-lg border border-border text-muted-foreground transition-colors hover:bg-muted hover:text-foreground'
      }
      aria-label={themeLabel}
      title={themeLabel}
    >
      <ThemeIcon size={size} aria-hidden />
    </button>
  );
}
